export default __webpack_public_path__ + "static/media/Yuki_Icon.844b711c.png";